import { HttpClient } from '@wix/sdk-types';
import {
  CalculateTaxOptions,
  CalculateTaxResponse,
  CalculateTaxResponseNonNullableFields,
  ListTaxCalculatorsResponse,
  ListTaxCalculatorsResponseNonNullableFields,
  calculateTax as universalCalculateTax,
  listTaxCalculators as universalListTaxCalculators,
} from './gateways-billing-v1-tax-calculation-gateway-tax-calculation.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function calculateTax(httpClient: HttpClient): CalculateTaxSignature {
  return (options?: CalculateTaxOptions) =>
    universalCalculateTax(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface CalculateTaxSignature {
  /**
   * Calculates tax for the provided line items.
   *
   * Tax is calculated for each line item based on the tax region
   * that corresponds to the address provided in `lineItems.addressIndex` and the tax group in `taxGroupId`. If no tax region is found for
   * the line item's address then no tax will be calculated for this line item. If no tax group with that `taxGroupId` is found then the
   * default tax group is used to calculate tax. Call List Default Tax Groups to retrieve a site's default tax groups.
   *
   * The tax is calculated by a tax calculator app installed on the site.
   * Call List Tax Calculators to see which tax calculators are available.
   * To provide your own tax calculations, use the Tax Calculation service plugin.
   *
   * The breakdown of calculated tax returned, includes:
   * + `taxSummary`: The overall total tax calculated.
   * + `taxSummary.aggregatedTaxBreakdown`: The total tax calculated for each jurisdiction.
   * + `lineItemTaxDetails.taxSummary`: The total tax calculated for each line item.
   * + `lineItemTaxDetails.taxBreakdown`: The tax calculated for each line item in each jurisdiction.
   * @param - Calculate tax options.
   */
  (options?: CalculateTaxOptions | undefined): Promise<
    CalculateTaxResponse & CalculateTaxResponseNonNullableFields
  >;
}

export function listTaxCalculators(
  httpClient: HttpClient
): ListTaxCalculatorsSignature {
  return () =>
    universalListTaxCalculators(
      // @ts-ignore
      { httpClient }
    );
}

interface ListTaxCalculatorsSignature {
  /**
   * Retrieves a list of installed tax calculators.
   *
   * Wix uses these calculators to calculate tax.
   */
  (): Promise<
    ListTaxCalculatorsResponse & ListTaxCalculatorsResponseNonNullableFields
  >;
}

export {
  Address,
  AddressIndex,
  AddressIndexAddressIndexOptionsOneOf,
  AggregatedTaxBreakdown,
  ApplicationError,
  CalculateTaxOptions,
  CalculateTaxRequest,
  CalculateTaxResponse,
  CalculateTaxResponseNonNullableFields,
  JurisdictionType,
  LineItem,
  LineItemTaxDetails,
  LineItemTaxSummary,
  ListTaxCalculatorsRequest,
  ListTaxCalculatorsResponse,
  ListTaxCalculatorsResponseNonNullableFields,
  MultipleAddresses,
  TaxBreakdown,
  TaxCalculationGateway,
  TaxCalculatorDetails,
  TaxSummary,
} from './gateways-billing-v1-tax-calculation-gateway-tax-calculation.universal.js';
